const initialState = {
  userPermissions: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'USER_PERMISSIONS':
      const { userPermissions } = action;
      return {
        ...state,
        userPermissions,
      };
    default:
      return state;
  }
};

export const setUserPermissions = (userPermissions) => ({
  type: 'USER_PERMISSIONS',
  userPermissions,
});
